import React, { useState } from "react";
import cn from "classnames";
import style from "./partnersItemTable.module.scss";
import { useScreenSize } from "../../hooks/useScreenSize";
import { useTranslation } from "react-i18next";
import PartnerProfileModal from "./components/PartnerProfileModal";

const PartnersItemTable = ({
  partners = [],
  isLoading = false,
  user,
  isShowModal,
  setShowModal,
  onRefresh,
}) => {
  const { isMobileView } = useScreenSize();
  const { t } = useTranslation();
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState(null);

  const getStatusLabel = (state) => {
    switch (state) {
      case "Draft":
        return "partnersPage.statuses.draft";
      case "Pending":
        return "partnersPage.statuses.pending";
      case "Moderation":
        return "partnersPage.statuses.moderation";
      case "Confirmed":
        return "partnersPage.statuses.active";
      case "Rejected":
        return "partnersPage.statuses.rejected";
      case "UnActive":
        return "partnersPage.statuses.inactive";
      case "RecoveryRequest":
        return "partnersPage.statuses.recoveryRequest";
      default:
        return state;
    }
  };

  const statusColors = {
    Draft: "#6d94ffff",
    Pending: "#6d7885",
    Moderation: "#6d7885",
    Confirmed: "#048848",
    Rejected: "#9E0812",
    UnActive: "#9E0812",
    RecoveryRequest: "#9E0812",
  };

  const handleShowProfile = (partner) => {
    setSelectedPartner(partner);
    setShowModalInfo(true);
  };

  return (
    <>
      <div className={style.tableSection}>
        <div className={style.tableContainer}>
          <table className={style.partnersTable}>
            <thead>
              <tr>
                {!isMobileView && <th></th>}
                <th>{t("partnersPage.table.registrationDate")}</th>
                <th>{t("partnersPage.table.companyName")}</th>
                <th>{t("partnersPage.table.status")}</th>
                <th>{t("partnersPage.table.actions")}</th>
              </tr>
            </thead>
            <tbody>
              {partners.map((partner) => (
                <tr key={partner.id}>
                  {!isMobileView && (
                    <td>
                      <div className={style.checkbox}></div>
                    </td>
                  )}
                  <td className={style.date}>
                    {new Date(partner.createdAt).toLocaleDateString("ru-RU", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                    })}
                  </td>
                  <td className={style.companyName}>{partner.companyName}</td>
                  <td>
                    <span
                      className={style.status}
                      style={{ color: statusColors[partner.state] || "#6d7885" }}
                    >
                      {t(getStatusLabel(partner.state))}
                    </span>
                  </td>
                  <td>
                    <button className={style.actionButton} onClick={() => handleShowProfile(partner)}>
                      {t("partnersPage.viewProfile")}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {showModalInfo && selectedPartner && (
        <PartnerProfileModal
          item={selectedPartner}
          setShowModalInfo={setShowModalInfo}
          onRefresh={onRefresh}
        />
      )}
    </>
  );
};

export default PartnersItemTable;
